export const colorStatusMapping = {
  COMPLETE: '#50C6CB',
  REACHED_DESTINATION_PORT: '#50C6CB',
  DELAYED: '#E9564D',
  ON_TIME: '#4EB83E',
  ARRIVING_EARLY: '#85EA96',
};
